import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent {

  constructor(
    private router:Router,
    private localStorageService: LocalStorageService,
  ){}

  home(){
    this.router.navigate(['/home/dashboard'])
  }

  login() {

    this.localStorageService.clearSession();

    this.router.navigate(['/login']);
  }
}
